<template>
  <v-container fill-height class="errors-wrapper">
    <v-row align="center" justify="center">
      <v-col>
        <div class="d-flex flex-column align-center justify-center h-100">
          <h1>:(</h1>
          <h3 class="title font-weight-regular mt-8">
            {{ $t('errors.BrowerNotSupportedMessage') }}
          </h3>
          <div class="mt-3 grey--text text--darken-1">
            {{ $t('errors.BrowerNotSupportedDescription') }}
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {}
</script>
